'use es6';

import http from 'hub-http/clients/apiClient';
import { formatPathSlug } from 'DesignData/lib/path';
const BASE_RAW_ASSET_URL = 'designmanager/v1/projects';
const PROJECTS_URL = 'dfs/v1/projects';
/**
 *  GET designmanager/v1/projects/staged-files/:projectPath
 */

export function fetchStagedFiles(projectPath) {
  return http.get(`${BASE_RAW_ASSET_URL}/staged-files/${formatPathSlug(projectPath)}`);
}
export function fetchProjects() {
  return http.get(PROJECTS_URL);
}
export function fetchBuilds(projectName) {
  return http.get(`${PROJECTS_URL}/${projectName}/builds`);
}